import { render } from "./Services.vue?vue&type=template&id=3067441f&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=3067441f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3067441f"]])

export default __exports__